import { render, staticRenderFns } from "./PriceCategoryCustomPercentSection.vue?vue&type=template&id=541faac8"
import script from "./PriceCategoryCustomPercentSection.vue?vue&type=script&lang=js"
export * from "./PriceCategoryCustomPercentSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports